import { List } from 'immutable';

import { launchDarklyState } from './launchDarkly';

export const state = List([launchDarklyState]);

export { launchDarklyState as featureFlagState } from './launchDarkly';
